import { Component } from '@angular/core';
import { NgxMarqueeComponent } from '@omnedia/ngx-marquee';
@Component({
    selector: 'customized-section',
    standalone: true,
    imports: [NgxMarqueeComponent],
    templateUrl: './customized-section.component.html',
    styleUrl: './customized-section.component.less',
})
export class CustomizedComponent {}
